import {Component} from 'react';

class DocumentLinkCard extends Component {
    constructor(props) {
        super(props);
        this.state = {open: false, selected: false};
    }

   
    render() {
        //https://assets.playmoneytrain.com/<file-name>
        const hrefName = 'https://assets.playmoneytrain.com/' + this.props.outInfo.linkItem + ".pdf";
    
    return <>
        <div>
            <a className="decorative light-blue-color text-pointer" 
                href={hrefName} target="_blank" 
                    rel="noreferrer">
                {this.props.outInfo.linkText} 
            </a>
        </div> 
    </>
    }
}

export default DocumentLinkCard;